module.exports = __webpack_public_path__ + "static/media/Termini e condizioni Rider.7cbbb5af.pdf";